import React, { useEffect, useState } from "react";
import { CancelModalContainer, CustomCheckbox, ModalContainer, SelectBox } from "../styled";
import SectionHeader from "../../common/sectionTitle";
import { AiOutlineClose } from "react-icons/ai";
import { RiArrowGoBackFill } from "react-icons/ri";
import useGlobalScroll from "../../../../../hooks/useGlobalScroll";
import { renderProductInfo } from "../../../common/function/shopping";
import { toast } from "react-toastify";
import SelectProducts from "./cancel/selectProducts";
import Reason from "./cancel/reason";
import axios from "axios";

const CancelModal = ({ toggleModal, selection, openModal, closeModal, getData }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const transformValue = { transform: `translateX(${activeIndex * -100}%)` };

  useEffect(() => {
    if (!selection) return;
    console.log(selection);
    setSelectedProducts((selection?.products || []).map((product) => product.productId));
  }, [selection]);

  useGlobalScroll();

  const handleProductToggle = (productId) => {
    setSelectedProducts((prev) =>
      prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId],
    );
  };

  const handleSelectChange = (e) => {
    setSelectedReason(e.target.value);
    if (e.target.value !== "기타 (직접 입력)") {
      setCustomReason("");
    }
  };

  const validationCheck = () => {
    if (activeIndex === 0) {
      if (selectedProducts.length === 0) {
        toast.error("상품을 하나 이상 선택해주세요.");
        return false;
      }
      return true;
    }

    const isEtc = selectedReason === "기타 (직접 입력)";
    const reasonToSubmit = isEtc ? customReason.trim() : selectedReason;

    if (!reasonToSubmit) {
      toast.error("취소 사유를 입력해주세요.");
      return false;
    }

    return true;
  };

  const updateCancel = async () => {
    const isEtc = selectedReason === "기타 (직접 입력)";
    const cancelReason = isEtc ? customReason.trim() : selectedReason;

    const url = "/erp/customerOrder/cancel";
    const body = {
      input: {
        customerOrderId: selection.id,
        cancelReason,
      },
    };

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("주문이 성공적으로 취소되었습니다.");
        toggleModal();
        await getData();
      }
    } catch (error) {
      toast.error("잠시후 다시 시도해주십시오");
    } finally {
      closeModal();
    }
  };

  const handleSubmit = () => {
    if (!validationCheck()) return;

    if (activeIndex === 0) {
      setActiveIndex(1);
    } else {
      openModal({
        isOpen: true,
        type: "confirmation",
        title: `주문 취소`,
        message: [`주문을 취소하시겠습니까?`],
        handleConfirm: () => updateCancel(),
        handleCancel: () => closeModal(),
      });
    }
  };

  return (
    <ModalContainer onClick={(e) => e.target === e.currentTarget && toggleModal()}>
      <CancelModalContainer>
        <div className="modal">
          <div className="form">
            <SectionHeader
              title="주문 취소"
              action={{
                icon: activeIndex ? RiArrowGoBackFill : AiOutlineClose,
                className: "close",
                clickEvent: () => (activeIndex ? setActiveIndex(0) : toggleModal()),
              }}
            />
            <div className="slideWrapper">
              <div className="slideContent" style={transformValue}>
                <SelectProducts
                  products={selection.products}
                  selectedProducts={selectedProducts}
                  onToggle={handleProductToggle}
                />
              </div>
              <div className="slideContent" style={transformValue}>
                <Reason
                  selectedReason={selectedReason}
                  onSelectChange={handleSelectChange}
                  customReason={customReason}
                  onCustomChange={(e) => setCustomReason(e.target.value)}
                />
              </div>
            </div>
          </div>
          <button className="submit" onClick={handleSubmit}>
            확인
          </button>
        </div>
      </CancelModalContainer>
    </ModalContainer>
  );
};

export default CancelModal;
